export default ['JsonRPCService', '$rootScope', function (JsonRPCService, $rootScope) {
    return {
        getAccountContacts: function getAccountContacts(accountNumber, roles, fromPage, pageSize) {
            return JsonRPCService.send('pc', 'gateway/contact', 'getMainAccountContacts', [accountNumber, roles || [], fromPage || 0, pageSize || 10]);
        },
        getRelatedAccountContacts: function getRelatedAccountContacts(accountNumber, relationships, fromPage, pageSize) {
            return JsonRPCService.send('pc', 'gateway/contact', 'getRelatedAccountContacts', [accountNumber, fromPage || 0, pageSize || 10, relationships || []]);
        },
        getCommonAccountContacts: function getCommonAccountContacts(accountNumber, fromPage, pageSize) {
            return JsonRPCService.send('pc', 'gateway/contact', 'getCommonAccountContacts', [accountNumber, fromPage || 0, pageSize || 10]);
        },
        getAccountContactDetails: function getAccountContactDetails(contactId) {
            return JsonRPCService.send('pc', 'gateway/contact', 'getAccountContactDetails', [contactId]);
        },
        assignContact: function assignContact(contactPublicId) {
            $rootScope.contactPublicId = contactPublicId;
        },
        getPolicyContactSummaries: function getPolicyContactSummaries(policyNumber, roles, fromPage, pageSize) {
            return JsonRPCService.send('pc', 'gateway/contact', 'getPolicyContactSummaries', [policyNumber, roles || [], fromPage || 0, pageSize || 10]);
        },
        getPolicyContactDetails: function getPolicyContactDetails(contactId, policyNumber) {
            return JsonRPCService.send('pc', 'gateway/contact', 'getPolicyContactDetails', [contactId, policyNumber]);
        }
    };
}];


//////////////////
// WEBPACK FOOTER
// ./common/js/src/edge/gateway/services/ContactService.js
// module id = 1785
// module chunks = 0